import { render, staticRenderFns } from "./ListNormalRight.vue?vue&type=template&id=19c2b780&"
import script from "./ListNormalRight.vue?vue&type=script&lang=js&"
export * from "./ListNormalRight.vue?vue&type=script&lang=js&"
import style0 from "./ListNormalRight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports